
export default () => ({

  show: true,
  arrowDown: true,

  scroll() {
    if(document.getElementById('contact-block').getBoundingClientRect().bottom - document.documentElement.clientHeight > 0) {
      this.arrowDown = true;
    }
    else {
      this.arrowDown = false;
    }
    if(window.scrollY + document.documentElement.clientHeight >= document.body.scrollHeight - this.$refs.bar.offsetHeight) {
      this.show = false;
    }
    else {
      this.show = true;
    }
  },

  init() {
  },
});
